export default class Board {
  constructor(name, mtlFile, objFile, image, previewImage) {
    this.name = name;
    this.mtlFile = mtlFile;
    this.objFile = objFile;
    this.image = image;
    this.previewImage = previewImage;
  }

  isValid() {
    return this.name && this.mtlFile && this.objFile && this.image && this.previewImage;
  }
}